<template>
  <div class="pb-10">
    <div class="page-title-box mb-8">
      <h1>
        이제 돈 걱정 없이<br />
        마음껏 사입하세요!
      </h1>
      <p>판매중인 플랫폼을 선택해 주세요.</p>
    </div>

    <v-list v-if="providers">
      <v-list-item-group v-model="selectedItem">
        <v-scroll-y-transition group>
          <MallListItem
            v-for="(provider, index) in providers"
            :key="index"
            :item="provider"
            :loading="loading"
            @click="clickTempSignup"
          />
        </v-scroll-y-transition>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MallListItem from '@/components/mall/MallListItem.vue'

export default {
  components: { MallListItem },
  data() {
    return {
      selectedItem: null,
      loading: false,
    }
  },
  async created() {
    await this.getMallProviders()
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('mall', { storeProviders: 'providers' }),
    providers() {
      if (!this.storeProviders) return []

      const availableProviders = this.storeProviders.filter((v) => v.isAvailable === true)
      const unavailableProviders = this.storeProviders.filter((v) => v.isAvailable !== true)
      unavailableProviders.push({
        name: '플랫폼 추가 요청',
      })

      return availableProviders.concat(unavailableProviders)
    },
  },
  methods: {
    ...mapActions('mall', ['getMallProviders']),
    ...mapActions('signup', ['tempSignup']),

    async clickTempSignup(mall) {
      if (this.loading) return

      try {
        this.loading = true
        const body = {
          body: {
            email: this.me.email,
            phone: this.me.phone,
            mall: mall.code,
          },
        }
        await this.tempSignup(body)

        // 플랫폼 추가 클릭한 경우
        if (!mall.code) {
          await this.$router.push({ name: 'signup/platform/require' })
          return
        }

        // 지원되지 않는 플랫폼 선택한 경우
        if (!mall.isAvailable) {
          await this.$router.push({ name: 'signup/platform/notavailable' })
          return
        }

        await this.$router.push({ name: 'signup/mall', params: { provider: mall.code } })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
